<template>
  <v-row>
    <v-col cols="12" v-for="(item, i) in localAchievementParent.list" :key="i">
      <AchievementDocComponent
        :index="i"
        :item="item"
        @set-data="setAchievement($event, item)"
        @remove="removeAchievement(item)"
      />
    </v-col>

    <v-col
      cols="12"
      class="d-flex justify-end pt-0"
      v-if="localAchievementParent.list.length < 5"
    >
      <v-btn
        color="primary"
        outlined
        rounded
        @click="addAchievement"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Добавить документ о достижении
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import AchievementDocComponent from '@/components/zvp/application-create/achievement-doc/AchievementDoc'
import {AchievementParent, Achievement} from '@/models'
import _cloneDeep from "lodash/cloneDeep";

export default {
  name: "AchievementDoc",

  components: {
    Title,
    AchievementDocComponent
  },

  props: {
    item: AchievementParent
  },

  data: () => ({
    localAchievementParent: new AchievementParent(),
  }),

  computed: {},

  methods: {
    addAchievement() {
      this.localAchievementParent.list.push(new Achievement())
    },

    setAchievement(event, item) {
      item.setProperties(event)
      this.$emit('set-data', _cloneDeep(this.localAchievementParent))
    },

    removeAchievement(item) {
      this.$emit('remove', item)
      this.localAchievementParent.remove(item)
    },
  },

  watch: {
    'item.list.length': {
      immediate: true,
      handler(value) {
        this.localAchievementParent = _cloneDeep(this.item)
      }
    }
  }
}
</script>

<style scoped>
</style>
